import React from 'react';
import { Table } from 'semantic-ui-react';

// Components
// @ts-ignore
import TableHeadTableCell from 'components/TableHeadTableCell';
import PeopleTableCheckbox from '../PeopleTableCheckbox';

interface Props {
    ids: number[];
}

const PeopleTableHead = ({ ids }: Props): React.ReactElement => (
    <Table.Header
        // HACK inline styles
        style={{
            fontSize: 14
        }}
    >
        <Table.Row>
            <Table.HeaderCell className="checkbox">
                <PeopleTableCheckbox rowId={ids} />
            </Table.HeaderCell>
            <TableHeadTableCell
                label="First Name"
                value="firstName"
                defaultSort="firstName"
            />
            <TableHeadTableCell label="Last Name" value="lastName" />
            <TableHeadTableCell label="Payroll Number" value="datacomId" />
            <Table.HeaderCell style={{ padding: 8, cursor: 'auto' }}>
                Groups
            </Table.HeaderCell>
            <TableHeadTableCell label="Email" value="email" />
            <Table.HeaderCell style={{ padding: 8, cursor: 'auto' }}>
                Roles
            </Table.HeaderCell>
            <Table.HeaderCell />
        </Table.Row>
    </Table.Header>
);

export default PeopleTableHead;
